(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcement = document.querySelector('.announcement-bar');
      
      if (this.announcement) {
        this.setVisibility();
        this.dismissBtn = this.announcement.querySelector('[data-dismiss-announcement]');
        if (!this.dismissBtn) return;
        this.dismissBtn.addEventListener('click', this.dismissAnnouncement.bind(this));
      }

      this.announcementBarSection = document.querySelector('.announcement-bar-section');
      if (this.announcementBarSection) {
        window.requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBarSection.scrollHeight}px`);
        });
      }
    }

    dismissAnnouncement() {
      this.announcement.classList.add('is-dismissed');
      this.announcement.classList.remove('is-shown');
      sessionStorage.setItem('announcement-dismissed', true);
      window.requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      });
    }

    setVisibility() {
      this.checkDismissed = sessionStorage.getItem('announcement-dismissed');
      if (this.checkDismissed == 'true') {
        this.announcement.classList.add('is-dismissed');
        this.announcement.classList.remove('is-shown');
        window.requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        });
      } else {
        this.announcement.classList.add('is-shown');
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content-with-sidebar"] && !window.DesignMode) return;
  try {
    
  class AccordionsSectionTabs extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        tabButtons: this.querySelectorAll('.faq-tabs__button'),
        panels: this.querySelectorAll('.faq-tabs__panel'),
        select: this.querySelector('.faq-tabs__select select'),
      };

      this.elements.tabButtons.forEach(btn => {
        btn.addEventListener('click', this.switchTab.bind(this));
        btn.addEventListener('keydown', event => {
          if (event.code === 'Enter' || event.code === 'Space') {
            event.preventDefault();
            switchTab.bind(this);
          }
        });
      });

      this.elements.select.addEventListener('change', this.switchTabSelect.bind(this));
    }

    switchTab(evt) {
      this.elements.tabButtons.forEach(tab => tab.setAttribute('aria-selected', false));
      this.elements.panels.forEach(panel => panel.setAttribute('aria-hidden', true));

      const button = evt.target.closest('.faq-tabs__button');
      button.setAttribute('aria-selected', true);
      const panelTargetId = button.getAttribute('aria-controls');
      const panel = Array.from(this.elements.panels).find(panel => panel.id === panelTargetId);
      panel.setAttribute('aria-hidden', false);

      // Sync the selected option in the select element
      const option = this.elements.select.querySelector(`[value="${panelTargetId}"]`);
      option.selected = true;

      const parentContainer = this.parentElement;
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      const yOffset = parentContainer.getBoundingClientRect().top - headerHeight - 60 + window.pageYOffset;
      window.scrollTo({
        top: yOffset,
        behavior: 'smooth',
      });
    }

    switchTabSelect(evt) {
      this.elements.tabButtons.forEach(tab => tab.setAttribute('aria-selected', false));
      this.elements.panels.forEach(panel => panel.setAttribute('aria-hidden', true));

      const option = evt.target.selectedOptions[0];
      const button = Array.from(this.elements.tabButtons).find(btn => btn.getAttribute('aria-controls') === option.value);
      button.setAttribute('aria-selected', true);
      const panel = Array.from(this.elements.panels).find(panel => panel.id === option.value);
      panel.setAttribute('aria-hidden', false);

      // Sync the active tab button
      const activeButton = this.querySelector('.faq-tabs__button[aria-selected="true"]');
      activeButton.setAttribute('aria-selected', false);
      button.setAttribute('aria-selected', true);
    }
  }

  customElements.define('accordions-section-tabs', AccordionsSectionTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-tabs"] && !window.DesignMode) return;
  try {
    
  class ContentTabs extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        tabButtons: this.querySelectorAll('.content-tabs__button'),
        panels: this.querySelectorAll('.content-tabs__panel'),
        textContainers: this.querySelectorAll('.content-tabs__text-content'),
      };

      this.elements.tabButtons.forEach(btn => {
        btn.addEventListener('click', this.switchTab.bind(this));
        btn.addEventListener('keydown', event => {
          if (event.code === 'Enter' || event.code === 'Space') {
            event.preventDefault();
            switchTab.bind(this);
          }
        });
      });

      this.initTruncation();
    }

    switchTab(evt) {
      this.elements.tabButtons.forEach(tab => tab.setAttribute('aria-selected', false));
      this.elements.panels.forEach(panel => panel.setAttribute('aria-hidden', true));

      const button = evt.target.closest('.content-tabs__button');
      button.setAttribute('aria-selected', true);
      const panelTargetId = button.getAttribute('aria-controls');
      const panel = Array.from(this.elements.panels).find(panel => panel.id === panelTargetId);
      panel.setAttribute('aria-hidden', false);

      const parentContainer = this.parentElement;
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      const yOffset = parentContainer.getBoundingClientRect().top - (headerHeight + 60) + window.pageYOffset;
      window.scrollTo({
        top: yOffset,
        behavior: 'smooth',
      });
    }

    initTruncation() {
      this.elements.textContainers.forEach(container => {
        const showMoreButton = container.nextElementSibling;

        if (!showMoreButton) return;

        if (container.scrollHeight > container.offsetHeight) {
          container.classList.add('is-truncated');
          showMoreButton.classList.add('is-visible');
        }

        container.classList.remove('initial');

        showMoreButton.addEventListener('click', () => {
          container.classList.toggle('is-truncated');
          if (container.classList.contains('is-truncated')) {
            showMoreButton.textContent = 'Read More [+]';
          } else {
            showMoreButton.textContent = 'Read Less [-]';
          }
        });
      });
    }
  }

  customElements.define('content-tabs', ContentTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-multi"] && !window.DesignMode) return;
  try {
    
  class BannerMulti extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        textPanels: this.querySelectorAll('.banner-multi__text-panel'),
        imagePanels: this.querySelectorAll('.banner-multi__image-panel')
      };

      this.elements.textPanels.forEach((textPanel, index) => {
        textPanel.addEventListener('mouseover', () => {
          this.elements.imagePanels.forEach(image => {
            image.classList.remove('active');
          });
          this
            .elements
            .imagePanels[index]
            .classList
            .add('active');
        });
      });
    }
  }

  customElements.define('image-banner-multi', BannerMulti);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-activity"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-care"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-faq"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-orders"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-profile"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-regenerate"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-relove"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-repair"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-resell"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-upcycle"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  // class VideoSection extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.elements = {
  //       video: this.querySelector('video'),
  //       button: this.querySelector('[data-play-pause]'),
  //     };

  //     this.elements.button.addEventListener('click', this.playVideo.bind(this));
  //     this.elements.video.addEventListener('play', this.videoIsPlaying.bind(this));
  //     this.elements.video.addEventListener('pause', this.videoIsPaused.bind(this));
  //   }

  //   playVideo() {
  //     this.elements.video.play();
  //   }

  //   videoIsPlaying() {
  //     this.elements.video.controls = true;
  //     this.classList.add('video-is-playing');
  //   }

  //   videoIsPaused() {
  //     this.elements.video.controls = false;
  //     this.classList.remove('video-is-playing');
  //   }
  // }

  // customElements.define('video-file-section', VideoSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-order"]) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-rewards"] && !window.DesignMode) return;
  try {
    
  (function() {
    const REDIRECT_PATH = '/account/login#recover';
    const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]:not(.logout-only)');
    logoutBtns.forEach(logoutBtn => {
      logoutBtn.addEventListener('click', function() {
        fetch(logoutBtn.href).then(() => (window.location.href = REDIRECT_PATH));
      });
    });

    const loyaltyContainer = document.querySelector('.loyalty-container');
    if (! loyaltyContainer) return;
    

    if (loyaltyContainer) {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            observer.disconnect();
            if (loyaltyContainer.classList.contains('show-welcome')) {
              clearActiveNav();
            }
            updatePanel();
          }
        }
      });

      observer.observe(loyaltyContainer, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    function clearActiveNav() {
      const menuItems = document.querySelectorAll('.lion-loyalty-panel-sidebar__menu-item');

      menuItems.forEach(item => {
        item.classList.remove('lion-active');
      });
    }

    function updatePanel() {
      const menuItems = document.querySelectorAll('.lion-loyalty-panel-sidebar__menu-item');

      menuItems.forEach(item => {
        item.addEventListener('click', () => {
          document.querySelector('.loyalty-container').classList.remove('show-welcome');
        });
      });

      if (! menuItems.length) {
        document.querySelector('.loyalty-container').classList.remove('show-welcome');
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-v2"] && !window.DesignMode) return;
  try {
    
  class MultiColumnGrid extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        textContainers: this.querySelectorAll('.multicolumn-card__text-content--truncatable'),
      };

      this.initTruncation();
    }

    initTruncation() {
      this.elements.textContainers.forEach(container => {
        const showMoreButton = container.nextElementSibling;

        if (!showMoreButton) return;

        if (container.scrollHeight > container.offsetHeight) {
          container.classList.add('is-truncated');
          showMoreButton.classList.add('is-visible');
        }

        container.classList.remove('initial');

        showMoreButton.addEventListener('click', () => {
          container.classList.toggle('is-truncated');
          if (container.classList.contains('is-truncated')) {
            showMoreButton.textContent = 'Read More [+]';
          } else {
            showMoreButton.textContent = 'Read Less [-]';
          }
        });
      });
    }
  }

  customElements.define('multi-column-grid', MultiColumnGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !window.DesignMode) return;
  try {
    
  class MultiColumnGrid extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        textContainers: this.querySelectorAll('.multicolumn-card__text-content--truncatable'),
      };

      this.initTruncation();
    }

    initTruncation() {
      this.elements.textContainers.forEach(container => {
        const showMoreButton = container.nextElementSibling;

        if (!showMoreButton) return;

        if (container.scrollHeight > container.offsetHeight) {
          container.classList.add('is-truncated');
          showMoreButton.classList.add('is-visible');
        }

        container.classList.remove('initial');

        showMoreButton.addEventListener('click', () => {
          container.classList.toggle('is-truncated');
          if (container.classList.contains('is-truncated')) {
            showMoreButton.textContent = 'Read More [+]';
          } else {
            showMoreButton.textContent = 'Read Less [-]';
          }
        });
      });
    }
  }

  customElements.define('multi-column-grid', MultiColumnGrid);

  } catch(e) { console.error(e); }
})();
})();
